import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5.js';
import jszip from 'jszip';
import pdfmake from 'pdfmake';

window.JSZip = jszip;
window.pdfMake = pdfmake;

// Import HEIC converter and make it globally available
import { convertHeicToJpeg, processImageUrls } from '../heic_converter';
window.convertHeicToJpeg = convertHeicToJpeg;
window.processImageUrls = processImageUrls;

// Import ActionCable consumer and make it globally available
import consumer from '../channels/consumer';
window.ActionCableConsumer = consumer;

require("channels")
import "controllers";

// Import receipt configuration module
import { initializeReceiptConfig } from '../receipt_config';
window.initializeReceiptConfig = initializeReceiptConfig;

// Import form flow fixes
import '../form_flow_fixes';

// Select-all action for unlimited multiselect dropdowns.
import '../multiselect_all';
